<template>
  <div>
    <el-popover
      ref="link"
      placement="top-start"
      :width="this.width"
      trigger="hover"
      popper-class="customPop">
        <a v-bind:href="toolLink" target="_blank">{{linkLabel}}</a>
    </el-popover>
    <img src="@/assets/status/question.svg" class="statusIcon" alt="" title="" v-popover:link/>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      default: 350
    },
    showLink: {
      default: false
    },
    linkLabel: {
      default: ''
    },
    toolLink: {
      default: ''
    },
    text: {
      default: 'Please give text'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .statusIcon {
    width: 27px;
    height: 27px;
  }
  .el-popover {
    text-align: initial !important;
  }
</style>
